import React from 'react';
import PropTypes from 'prop-types';
import CaseStudyPage from 'components/CaseStudyPage';

function CaseStudy({ pathContext }) {
  return <CaseStudyPage data={pathContext} />;
}

CaseStudy.propTypes = {
  pathContext: PropTypes.shape({}).isRequired,
};

export default CaseStudy;



// WEBPACK FOOTER //
// ./src/templates/CaseStudy.js